import { buildProps, definePropType } from '@ll-plus/utils'
import { ExtractPropTypes } from 'vue'

import type Rate from './rate.vue'

type Fn = (value: number | undefined) => any

export const rateProps = buildProps({
  value: Number,
  size: {
    type: Number,
    default: 24,
  },
  color: {
    type: String,
    default: '#fadb14',
  },

  // 自定义文字
  customText: {
    type: definePropType<Fn | string | number>([Function, String]),
    default: undefined,
  },
} as const)

export type RateProps = ExtractPropTypes<typeof rateProps>

export type RateInstance = InstanceType<typeof Rate>
